import { render, staticRenderFns } from "./specialistItem.vue?vue&type=template&id=0de3d3da&"
import script from "./specialistItem.vue?vue&type=script&lang=js&"
export * from "./specialistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports